const personsRoute = [
    {
        path: "/persons",
        name: "persons",
        component: () => import("@/views/persons/Persons")
    },

    {
        path: "/persons/create",
        name: "personCreate",
        component: () => import("@/views/persons/PersonsEdit")
    },
    {
        path: "/persons/:id",
        name: "person",
        component: () => import("@/views/persons/Person"),
        props: route => {
            const id = Number.parseInt(route.params.id, 10);
            if (Number.isNaN(id)) {
                return 0;
            }
            return {id};
        }
    },
    {
        path: "/persons/:id/edit",
        name: "personsEdit",
        component: () => import("@/views/persons/PersonsEdit"),
        props: route => {
            const id = Number.parseInt(route.params.id, 10);
            if (Number.isNaN(id)) {
                return 0;
            }
            return {id};
        }
    },
]
export default personsRoute